import { create } from 'zustand';

/**
 * "The viewer is standing on their own storefront."
 *
 * It lives in `lib/stores/` rather than inside the storefront because two
 * unrelated places need it: the storefront sets it, and the site bar — which
 * is rendered once for the whole app by the root layout and cannot be handed
 * props by a page it does not contain — reads it to light the My-page item on
 * exactly that page. (Its sibling `feature-shortcut` store is gone: the control
 * it carried moved onto the storefront itself, so it needed no courier.)
 *
 * There is no edit mode any more (removed 2026-08-21): the owner's page is
 * quietly editable in place where it needs to be (Identity's name/tagline,
 * the Links section's own editor), so "owning" is the whole state.
 */
interface OwnerModeState {
  owning: boolean;
  setOwning: (owning: boolean) => void;
}

export const useOwnerMode = create<OwnerModeState>((set) => ({
  owning: false,
  setOwning: (owning) => set({ owning }),
}));
